<template>
  <div class="antraege-search-page-container">
    <v-container class="antraege-search-page pa-0" fluid>
      <div class="primary--text semanticsection-title2">
        Antragssuche/Angebotssuche
      </div>
      <v-row no-gutters>
        <v-text-field v-model="vorgangsnummer"
                      v-validate="{required: true, regex: /^[0-9]{10}$|^[0-9]{6}$|[0-9A-Z]-/ }"
                      :error-messages="errors.collect('Vorgangsnummer')"
                      :loading="isLoading"
                      data-vv-as="Antrags-/Angebotsnummer"
                      data-vv-validate-on="blur"
                      class="input-vorgangsnummer mr-3"
                      mask="##########"
                      append-icon="search"
                      clearable
                      hint="10-stellige Antrags- oder Angebotsnummer oder Action-ID oder 6-stellige VSNR"
                      name="Vorgangsnummer"
                      label="Antrags-/Angebotsnummer"
                      @keyup.enter="loadAntrag(vorgangsnummer)"
                      @input="errors.remove('Vorgangsnummer')" />
        <v-btn color="primary"
               @click="loadAntrag(vorgangsnummer)">
          Suchen
        </v-btn>
      </v-row>
      <div v-if="loadingErrorMessage"
           class="error--text mb-4">
        {{ loadingErrorMessage }}
      </div>
      <div v-if="resultItems !== null" class="details-table">
        <v-data-table 
                  :items="resultItems"
                  hide-default-header
                  hide-default-footer
                  class="no--hover">
          <template v-slot:item="{ item }">
            <tr>
              <td>{{ item.label }}</td>
              <td v-if="item.label === 'Schnittstellen-PDF'"
                    class="value-data-cell">
                  <a :href="item.value.path"
                    target="_blank"> {{ item.value.name }}
                  </a>
              </td>
              <td v-else-if="item.label === 'Angebots-PDF'"
                    class="value-data-cell">
                  <a :href="item.value.path"
                    target="_blank"> {{ item.value.name }}
                  </a>
                </td>
                <td v-else-if="item.label === 'Angehängte Dokumente'"
                    class="value-data-cell">
                  <div v-if="item.value.length === 0">Keine Dokumente</div>
                  <template v-else>
                    <div v-for="document in item.value"
                        :key="document.pfad">
                      <a :href="document.pfad"
                        target="_blank"> {{ document.name }}
                      </a>
                    </div>
                  </template>
                </td>
                <td v-else 
                    class="value-data-cell"
                    v-html="item.value">
                </td>
              </tr>
          </template>
        </v-data-table>
        <template v-if="false">
          <div class="dmb-form-text mt-3">Sie können den Antrag samt aller Dokumente erneut senden, geben Sie zuvor einen Bearbeitungshinweis ein:</div>
          <v-text-field v-model="processingInfo"
                        v-validate="{required: true}"
                        :error-messages="errors.collect('Bearbeitungshinweis')"
                        :loading="isSending"
                        clearable
                        name="Bearbeitungshinweis"
                        label="Bearbeitungshinweis" />
          <v-btn color="primary"
                @click="resendAntrag()">
            Erneut senden
          </v-btn>

          <div :class=" resendFailed ? 'error--text' : 'success--text'"
              class="dmb-form-text mt-2"> {{ resendResultMessage }}
          </div>
        </template>
        <div class="semanticsection-title primary--text">Schnittstellentext:</div>
        <div v-for="(value, key) in interfaceData"
             :key="key">
          {{ key }}: {{ value }}
        </div>

      </div>

    </v-container>
  </div>
</template>

<script>
import ValidationMixin from "@/components/helper/ValidationMixin";
import httpService from "@/helper/httpService";
import {API_URL} from "@/helper/httpService";
import {API_URL_SERVER} from "@/helper/httpService";
import {API_URL_LEGACY} from "@/helper/httpService";

function isGewerbe(antragstyp) {
  const gewerbeRegExps = [/Gewerbe-RS/i, /KOMedEX/i];
  return gewerbeRegExps.some(gewerbeRegExp => gewerbeRegExp.test(antragstyp));
}

export default {
  name: "AntraegeSearchPage",
  mixins: [ValidationMixin],
  data() {
    return {
      vorgangsnummer: null,
      isLoading: false,
      loadingErrorMessage: "",
      queryResult: null,
      isSending: false,
      resendFailed: false,
      resendResultMessage: "",
      processingInfo: ""
    };
  },
  computed: {
    isOffer() {
      if(this.resultItems && this.queryResult.isOffer){
        return true;
      } else {
        return false;
      }
    },
    resultItems() {
      if (this.queryResult === null) {
        return null;
      } else {
        return this.formatAntragToLableValueItems(this.queryResult);
      }
    },
    interfaceData() {
      const interfaceData = { ...this.queryResult };
      delete interfaceData.legacy;
      delete interfaceData.submitTime;
      delete interfaceData.antragstyp;
      delete interfaceData.pdf;
      delete interfaceData.attachments;
      return interfaceData;
    }
  },
  methods: {
    loadAntrag(vorgangsnummer) {
      this.queryResult = null;
      this.$validator.validate("Vorgangsnummer").then((result) => {
        if (result) {
          this.isLoading = true;
          httpService.getAntrag(vorgangsnummer)
            .then(result => {
              this.queryResult = result;
              this.loadingErrorMessage = null;
              this.resendFailed = false;
              this.resendResultMessage = "";
              this.isLoading = false;
            })
            .catch(error => {
              if (error.status === 404) {
                this.loadingErrorMessage = `Antrags-/Angebotsnummer ${vorgangsnummer} nicht gefunden.`;
              } else {
                const errorBodyText = error.body ? ` (${JSON.stringify(error.body)})` : "";
                this.loadingErrorMessage = `${error}${errorBodyText}`;
              }
              this.queryResult = null;
              this.isLoading = false;
            });
        }
      });
    },
    formatAntragToLableValueItems(antrag) {
      let parsedData = {
        isOffer: antrag.isOffer,
        vorgangsnummer: antrag.txtvorgangsnummer,
        submitTime: antrag.submitTime,
        antragstyp: antrag.antragstyp,
        versicherungsnehmer: isGewerbe(antrag.antragstyp) ? antrag.vn1name$txtfirma1 : antrag.txtvnvorname + " " + antrag.txtvnnachname,
        vermittler: antrag.txtvmnr || antrag.vmnr,
        pdf: antrag.pdf,
        documents: antrag.attachments,
        syspdf: antrag.syspdf ?? "",
        anmerkungenarchiv: (antrag.anmerkungenarchiv ?? "---").replaceAll("\n","<br>").replaceAll("<br><br>","<br>"),
        anmerkungen: (antrag.anmerkungen ?? "---").replaceAll("\n","<br>"),
        status: antrag.status
      };
      if (!antrag.legacy) {
        parsedData.pdf.path = parsedData.pdf.path + "?disposition=inline";
        if( parsedData.pdf.path.indexOf("api/")){
          parsedData.pdf.path = API_URL + parsedData.pdf.path.substring(parsedData.pdf.path.indexOf("api/") + 4 );
        } else {
          parsedData.pdf.path = API_URL_SERVER + parsedData.pdf.path ;
        }
        parsedData.documents.forEach(document => document.pfad = `${document.pfad}?disposition=inline`);
        if (parsedData.syspdf.path.indexOf("maklerportal/")){
          parsedData.syspdf.path = parsedData.syspdf.path.replace("/maklerportal", API_URL_LEGACY);
        }
      }else{
        parsedData.pdf.path = parsedData.pdf.path.replace("/maklerportal", API_URL_LEGACY);
        parsedData.syspdf.path = parsedData.syspdf.path.replace("/maklerportal", API_URL_LEGACY);
      }

      return [
        {
          label: "Antrags-/Angebotsnummer",
          value: parsedData.vorgangsnummer
        },
        {
          label: "Eingangsdatum",
          value: parsedData.submitTime
        },
        {
          label: "Antragsart",
          value: parsedData.antragstyp
        },
        {
          label: "Versicherungsnehmer",
          value: parsedData.versicherungsnehmer
        },
        {
          label: "Vermittler",
          value: parsedData.vermittler
        },
        {
          label: "PIA Status",
          value: parsedData.status
        },
        {
          label: "Wichtige Anmerkungen",
          value: parsedData.anmerkungen
        },
        {
          label: "Weitere Anmerkungen",
          value: parsedData.anmerkungenarchiv
        },
        {
          label: "Angebots-PDF",
          value: parsedData.pdf
        },
        {
          label: "Schnittstellen-PDF",
          value: parsedData.syspdf
        },
        {
          label: "Angehängte Dokumente",
          value: parsedData.documents
        }
      ];
    },
    resendAntrag() {
      this.$validator.validate("Bearbeitungshinweis").then((result) => {
        if (result) {
          this.isSending = true;
          this.resendFailed = false;
          const toSend = { ...this.queryResult, processinginfo: this.processingInfo };
          httpService.resendAntrag(toSend)
            .then(() => {
              this.isSending = false;
              this.resendResultMessage = "Antrag wurde erfolgreich übermittelt.";
            })
            .catch(() => {
              this.isSending = false;
              this.resendFailed = true;
              this.resendResultMessage = "Fehler beim Senden! Sie müssen den Administrator des Maklerportals kontaktieren, um diesen Antrag erneut zu senden.";
            });
        }
      });

    }
  }
};
</script>

<style>
.antraege-search-page-container {
  margin: 0 48px 100px 48px;
  display: flex;
  justify-content: center;
}

.antraege-search-page {
  max-width: 768px;
  width: 768px;
}

.antraege-search-page .input-vorgangsnummer {
  max-width: 260px;
}

.antraege-search-page .details-table .v-data-table {
  width: 648px;
  max-width: 648px;
  margin: 0 0;
}
.antraege-search-page .details-table .v-data-table tr{
  width: 648px;
  max-width: 648px;
}

</style>
